<script>
import i18n from '@/i18n';

export default {
  props: {
    news: {
      type: Object,
    },
  },
  computed: {
    forum() {
      // eslint-disable-next-line radix
      return parseInt(this.news.textParams[1]) > 1
        ? i18n.t('news.template.party.applicationReceived.p3s')
        : i18n.t('news.template.party.applicationReceived.p3');
    },
  },
};
</script>

<template>
<div>
  {{$t('news.template.party.applicationReceived.p1')}}
  "{{news.textParams[0]}}"
  {{$t('news.template.party.applicationReceived.p2')}}
  <a href="#">{{news.textParams[1]}}</a>
  {{forum}}
</div>
</template>
